export default {
  en: {
    'components.mapping-page.title': 'Conversion Mappings',
    'components.mapping-page.filing-types': 'Filing Type',
    'components.mapping-page.mapping': 'Mapping',
    'components.mapping-page.no-results':
      'No mappings have been created for this registration yet.',
    'components.mapping-page.confirmation': 'Are you sure you want to delete this mapping?',
    'components.mapping.delete.success': 'Mapping deleted successfully.',
  },
};
